import React, { useCallback, useState } from 'react';

function formatSize(bytes) {
  if (!bytes) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

function CsvUploadZone({
  accept = '.csv,text/csv',
  file = null,
  onFile,
  disabled = false,
  label = 'Arraste o arquivo aqui ou clique para selecionar',
  hint = 'CSV UTF-8 ate 20 MB',
}) {
  const [dragging, setDragging] = useState(false);

  const handleDragOver = useCallback(
    (event) => {
      event.preventDefault();
      if (!disabled) setDragging(true);
    },
    [disabled],
  );

  const handleDragLeave = useCallback((event) => {
    event.preventDefault();
    setDragging(false);
  }, []);

  const handleDrop = useCallback(
    (event) => {
      event.preventDefault();
      setDragging(false);
      if (disabled) return;
      const dropped = event.dataTransfer?.files?.[0];
      if (dropped) onFile(dropped);
    },
    [disabled, onFile],
  );

  const handleChange = useCallback(
    (event) => {
      const selected = event.target.files?.[0];
      if (selected) onFile(selected);
      event.target.value = '';
    },
    [onFile],
  );

  const handleClear = useCallback(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      onFile(null);
    },
    [onFile],
  );

  const className = [
    'ccv2-upload-zone',
    dragging ? 'ccv2-upload-zone--drag' : '',
    disabled ? 'ccv2-upload-zone--disabled' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={className}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <input
        type="file"
        accept={accept}
        onChange={handleChange}
        disabled={disabled}
        aria-label={label}
      />
      {file ? (
        <>
          <span className="ccv2-upload-icon">📄</span>
          <span className="ccv2-upload-filename">{file.name}</span>
          <span className="ccv2-upload-sub">{formatSize(file.size)}</span>
          <button
            type="button"
            className="ccv2-btn ccv2-btn-outline ccv2-btn-sm ccv2-upload-clear"
            onClick={handleClear}
          >
            Remover
          </button>
        </>
      ) : (
        <>
          <span className="ccv2-upload-icon">⬆</span>
          <span className="ccv2-upload-label">{label}</span>
          <span className="ccv2-upload-sub">{hint}</span>
        </>
      )}
    </div>
  );
}

export default CsvUploadZone;
